import { render, staticRenderFns } from "./losscustomerManage.vue?vue&type=template&id=43eb463a"
import script from "./losscustomerManage.vue?vue&type=script&lang=js"
export * from "./losscustomerManage.vue?vue&type=script&lang=js"
import style0 from "./losscustomerManage.vue?vue&type=style&index=0&id=43eb463a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports